<template>
    <div id="slide_box" class="slide3">
        <div id="slide_content" :style="{background: siteCodeInfo[0].BACK_COLOR}">
            <div class="slide_block" id="slide3" :class="getShowClass()">
                <div class="slide_animate_block">
                    <div class="category" id="middle">
                        <form>
                            <div class="bg" :style="{background: siteCodeInfo[0].BACK_COLOR}">
                                <div class="wrap03 stitle_box">
                                    <h2 class="stitle"><span v-html="siteCodeInfo[0].MEDIUM_WORD1_PC"></span></h2>
                                    <p class="commonError" v-if="error.no_items">{{$msg.ERROR.MSG_1005}}</p>
                                    <p class="commonError" v-else-if="error.no_items_without_large">{{$msg.ERROR.MSG_1006}}</p>
                                    <CommonErrorMsgArea />
                                </div>
                                <div class="wrap01 form_box">
                                    <p class="caution_txt_01">※複数選択可能</p>
                                    <p v-if="siteCodeInfo[0].PRICING_METHOD == 1" class="comment_txt_01" v-html="siteCodeInfo[0].MEDIUM_WORD2_PC"></p>
                                    <div v-for="item in items" :key="item.code" class="form_block_02" :style="styleObject" :id="item.id">
                                        <div class="radio_box">
                                            <div class="img_box">
                                                <p class="img">
                                                    <img :src="item.image" :alt="item.name">
                                                </p>
                                            </div>
                                            <div class="form-Radio-02 radio_no">
                                                <label>
                                                    <input type="radio" :name="item.name + '1'" @click="setUnit(0, item)"
                                                    :checked="item.unit == 0"><span class="input_txt" :style="{backgroundColor :item.unit == 0? siteCodeInfo[0].SELECTED_BTN_COLOR:'', borderColor :item.unit == 0? siteCodeInfo[0].SELECTED_BTN_COLOR:''}">無し</span>
                                                </label>
                                                <label>
                                                    <input type="radio" :name="item.name + '1'" @click="setUnit(1, item)"
                                                    :checked="item.unit == 1"><span class="input_txt" :style="{backgroundColor :item.unit == 1? siteCodeInfo[0].SELECTED_BTN_COLOR:'', borderColor :item.unit == 1? siteCodeInfo[0].SELECTED_BTN_COLOR:''}">1<span class="units">台</span></span>
                                                </label>
                                                <label>
                                                    <input type="radio" :name="item.name + '1'" @click="siteCodeInfo[0].BIZ_FLG == '1'?setDefault(item):createNumArray(item)"
                                                    :checked="item.unit >= 2"><span class="input_txt" :style="{backgroundColor :item.unit >= 2? siteCodeInfo[0].SELECTED_BTN_COLOR:'', borderColor :item.unit >= 2? siteCodeInfo[0].SELECTED_BTN_COLOR:''}">2<span class="units">台以上</span></span>
                                                </label>
                                            </div>
                                            <p v-if="showFeeUp(item)" class="comment_txt_01">
                                                <span v-if="item.fee === 0">料金：無料</span>
                                                <span v-else>料金：{{item.fee.toLocaleString()}}円/台（税込{{item.fee_inc_tax.toLocaleString()}}円）</span>
                                            </p>
                                        </div>
                                        <div class="no_box" v-if="item.unitFlg && siteCodeInfo[0].BIZ_FLG == '1'">
                                            <div class="bg_box">
                                                <p class="title">台数を入力</p>
                                                <div class="form-Radio-02 unit_box">
                                                    <select class="form-Select" :style="{ width: '70px' }" @change="unitInput(item, $event)" :value="item.unit">
                                                        <option v-for="n in maxQuantityBiz - 1" :key="n" :value="n + 1">
                                                            {{ n + 1 }}
                                                        </option>
                                                    </select>
                                                    <span class="units">台</span>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="no_box" v-if="item.unitFlg && siteCodeInfo[0].BIZ_FLG != '1'">
                                            <div class="bg_box">
                                                <p class="title">台数を選択</p>
                                                <div class="form-Radio-02 label_box">
                                                    <label v-for="num in item.numArray" :key="num">
                                                        <input type="radio" :name="item.name + '2'" v-model="item.unit"
                                                        :value="num">
                                                        <span class="input_txt" :style="{backgroundColor :item.unit == num? siteCodeInfo[0].SELECTED_BTN_COLOR:'', borderColor :item.unit == num? siteCodeInfo[0].SELECTED_BTN_COLOR:''}">{{ num }}<span class="units">台</span></span>
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                        <div v-if="item.unit > 0" class="item_description_m1" v-html="displayItemDescription(item)"></div>
                                        <div v-if="siteCodeInfo[0].PRICING_METHOD == 2 && item.unit > 0">
                                            <div class="no_box" v-for="option in item.options" :key="option.fee_kbn.code">
                                                <div class="bg_box">
                                                    <p class="title option-fee-title">{{ option.fee_kbn.name }}を選択</p>
                                                    <div class="form-Radio-02 label_box option-fee-box">
                                                        <label v-for="fee_cat in option.fee_cat" :key="fee_cat.code">
                                                            <input type="radio" :name="'fee_kbn_' + item.code + option.fee_kbn.code" :value="fee_cat.code" v-model="item.selectedOptions[option.fee_kbn.code]['feeCat']" @change="setTotalFee(item)">
                                                            <span class="input_txt" :style="{backgroundColor :fee_cat.code == item.selectedOptions[option.fee_kbn.code]['feeCat']? siteCodeInfo[0].SELECTED_BTN_COLOR:'', borderColor :fee_cat.code == item.selectedOptions[option.fee_kbn.code]['feeCat']? siteCodeInfo[0].SELECTED_BTN_COLOR:''}">{{ fee_cat.name }}</span>
                                                        </label>
                                                    </div>
                                                    <p class="error" style="text-align:center" v-if="item.selectedOptions[option.fee_kbn.code]['required']">{{option.fee_kbn.name + $msg.ERROR.MSG_9991}}</p>
                                                </div>
                                            </div>
                                        </div>
                                        <p v-if="showFeeDown(item)" class="comment_txt_01">
                                            <span v-if="item.totalFee === 0">料金：無料</span>
                                            <span v-else>料金：{{item.totalFee.toLocaleString()}}円/台（税込{{item.totalFeeIncTax.toLocaleString()}}円）</span>
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div class="sp_spec_box" v-if="addItem.code">
                                <div class="wrap03 wrap03_sp">
                                    <h3 class="sstitle"><span>その他、以下サイズの家電はありますか？</span></h3>
                                    <p v-if="showFeeUp(addItem)" class="comment_txt_01">料金：{{addItem.fee.toLocaleString()}}円/台（税込 {{addItem.fee_inc_tax.toLocaleString()}}円）</p>
                                </div>
                                <div class="wrap01 wrap01_sp">
                                    <div class="form_block_02" id="sp_spec_middle">
                                        <div class="radio_box">
                                            <div class="img_box img_box_02">
                                                <p><img :src="siteCodeInfo[0].BOX_SIZE_IMAGE_PATH_PC" alt="3辺合計（縦横高）80～160cm　|　30kg以内"></p>
                                            </div>
                                            <div class="form-Radio-02 radio_no">
                                                <label>
                                                    <input type="radio" name="label" @click="setUnit(0, addItem)" :checked="addItem.unit == 0"><span class="input_txt" :style="{backgroundColor :addItem.unit  == 0? siteCodeInfo[0].SELECTED_BTN_COLOR:'', borderColor :addItem.unit  == 0? siteCodeInfo[0].SELECTED_BTN_COLOR:''}">無し</span>
                                                </label>
                                                <label>
                                                    <input type="radio" name="label" @click="setUnit(1, addItem)" :checked="addItem.unit == 1"><span class="input_txt" :style="{backgroundColor :addItem.unit == 1? siteCodeInfo[0].SELECTED_BTN_COLOR:'', borderColor :addItem.unit == 1? siteCodeInfo[0].SELECTED_BTN_COLOR:''}">1<span class="units">台</span></span>
                                                </label>
                                                <label>
                                                    <input type="radio" name="label" @click="siteCodeInfo[0].BIZ_FLG == '1'?setDefault(addItem):createNumArray(addItem)" :checked="addItem.unit >= 2"><span class="input_txt" :style="{backgroundColor :addItem.unit >= 2? siteCodeInfo[0].SELECTED_BTN_COLOR:'', borderColor :addItem.unit >= 2? siteCodeInfo[0].SELECTED_BTN_COLOR:''}">2<span class="units">台以上</span></span>
                                                </label>
                                            </div>
                                        </div>
                                        <div class="no_box" v-if="addItem.unitFlg && siteCodeInfo[0].BIZ_FLG == '1'">
                                            <div class="bg_box">
                                                <p class="title">台数を入力</p>
                                                <div class="form-Radio-02 unit_box">
                                                    <select class="form-Select" :style="{ width: '70px' }" @change="unitInput(addItem, $event)" :value="addItem.unit">
                                                        <option v-for="n in maxQuantityBiz - 1" :key="n" :value="n + 1">
                                                            {{ n + 1 }}
                                                        </option>
                                                    </select>
                                                    <span class="units">台</span>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="no_box" v-if="addItem.unitFlg && siteCodeInfo[0].BIZ_FLG != '1'">
                                            <div class="bg_box">
                                                <p class="title">台数を選択</p>
                                                <div class="form-Radio-02 label_box">
                                                    <label v-for="addNum in addItem.numArray" :key="addNum">
                                                        <input type="radio" name="addUnit" v-model="addItem.unit"
                                                        :value="addNum">
                                                        <span class="input_txt" :style="{backgroundColor :addItem.unit == addNum? siteCodeInfo[0].SELECTED_BTN_COLOR:'', borderColor :addItem.unit == addNum? siteCodeInfo[0].SELECTED_BTN_COLOR:''}">{{ addNum }}<span class="units">台</span></span>
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                        <div v-if="addItem.unit > 0" class="item_description_m1" v-html="displayItemDescription(addItem)"></div>
                                        <div v-if="siteCodeInfo[0].PRICING_METHOD == 2 && addItem.unit > 0">
                                            <div class="no_box" v-for="option in addItem.options" :key="option.fee_kbn.code">
                                                <div class="bg_box">
                                                    <p class="title option-fee-title">{{ option.fee_kbn.name }}を選択</p>
                                                    <div class="form-Radio-02 label_box option-fee-box">
                                                        <label v-for="fee_cat in option.fee_cat" :key="fee_cat.code">
                                                            <input type="radio" :name="'fee_kbn_' + addItem.code + option.fee_kbn.code" :value="fee_cat.code" v-model="addItem.selectedOptions[option.fee_kbn.code]['feeCat']" @change="setTotalFee(addItem)">
                                                            <span class="input_txt" :style="{backgroundColor :fee_cat.code == addItem.selectedOptions[option.fee_kbn.code]['feeCat']? siteCodeInfo[0].SELECTED_BTN_COLOR:'', borderColor :fee_cat.code == addItem.selectedOptions[option.fee_kbn.code]['feeCat']? siteCodeInfo[0].SELECTED_BTN_COLOR:''}">{{ fee_cat.name }}</span>
                                                        </label>
                                                    </div>
                                                    <p class="error" style="text-align:center" v-if="addItem.selectedOptions[option.fee_kbn.code]['required']">{{option.fee_kbn.name + $msg.ERROR.MSG_9991}}</p>
                                                </div>
                                            </div>
                                        </div>
                                        <p v-if="showFeeDown(addItem)" class="comment_txt_01">
                                            <span v-if="addItem.totalFee === 0">料金：無料</span>
                                            <span v-else>料金：{{addItem.totalFee.toLocaleString()}}円/台（税込{{addItem.totalFeeIncTax.toLocaleString()}}円）</span>
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div class="sp_spec_box" :style="{background: siteCodeInfo[0].BACK_COLOR, paddingBottom: '0px'}" v-if="totalUnits > 0">
                                <div class="form_box wrap02">
                                    <div class="form_block_02">
                                        <p class="comment_txt_01" v-html="'<p>中型サイズの家電製品を梱包する箱数を選択してください。</p>'"></p>
                                        <div class="radio_box">
                                            <div class="form-Radio-02 radio_no">
                                                <label>
                                                    <input type="radio" :checked="mediumBox.medium_box_cnt == 1" v-model="mediumBox.medium_box_cnt" :value="1">
                                                    <span class="input_txt" :style="{backgroundColor :mediumBox.medium_box_cnt == 1? siteCodeInfo[0].SELECTED_BTN_COLOR:'', borderColor :mediumBox.medium_box_cnt == 1? siteCodeInfo[0].SELECTED_BTN_COLOR:''}">1<span class="units">箱</span></span>
                                                </label>
                                                <label>
                                                    <input type="radio" :checked="mediumBox.medium_box_cnt >= 2" :disabled="totalUnits <= 1" v-model="mediumBox.medium_box_cnt" :value="2">
                                                    <span class="input_txt" :style="{backgroundColor :mediumBox.medium_box_cnt >= 2? siteCodeInfo[0].SELECTED_BTN_COLOR:'', borderColor :mediumBox.medium_box_cnt >= 2? siteCodeInfo[0].SELECTED_BTN_COLOR:''}" :class="{'invalid': totalUnits <= 1}">2<span class="units">箱以上</span></span>
                                                </label>
                                            </div>
                                        </div>
                                        <div class="no_box" v-if="mediumBox.unitFlg">
                                            <div class="bg_box">
                                                <p class="title">箱数を選択</p>
                                                <div class="form-Radio-02 unit_box">
                                                    <select class="form-Select" :style="{ width: '70px' }" v-model="mediumBox.medium_box_cnt">
                                                        <option v-for="n in (totalUnits - 1)" :key="n" :value="n + 1">
                                                            {{ n + 1 }}
                                                        </option>
                                                    </select>
                                                    <span class="units">箱</span>
                                                </div>
                                            </div>
                                        </div>
                                        <p class="error" style="text-align:center" v-if="mediumBox.mediumBoxSelectErrFlg">箱数を選択してください。</p>
                                    </div>
                                </div>
                            </div>
                            <div class="bg bg_bottom white" :class="{pd_top: !addItem.code}">
                                <div class="wrap03 btn_box">
                                    <p class="next_page">
                                        <button type="button" class="form-Button-01 move_slide" :style="{backgroundColor : siteCodeInfo[0].NEXT_PAGE_BTN_COLOR}" data-toslide="slide4" @click="submitMediumItems">
                                            <span v-if="smallView">手のひらサイズの家電へ</span>
                                            <span v-else>回収日時へ</span>
                                        </button>
                                    </p>
                                    <div class="link_box">
                                        <p class="back_page"><span class="form-Button-back move_slide" data-toslide="slide2" @click="pageBack">戻る</span></p>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import MediumItems from '../../js/MediumItemsForm'
import CommonErrorMsgArea from '@/components/pc/CommonErrorMsgArea'

export default {
    components: { CommonErrorMsgArea },
    props: {
        siteCodeInfo: Array,
        siteCodeItem: Array
    },
    data() {
        return {
            items: [
                {
                    code: MediumItems.common.constant.CODE_MICROWAVE,
                    name: MediumItems.common.constant.NAME_MICROWAVE,
                    unit: MediumItems.common.constant.UNIT_MICROWAVE,
                    maxUnit: MediumItems.common.constant.MAXUNIT_MICROWAVE,
                    bizMaxUnitErrFlg: false,
                    numArray: [],
                    unitFlg: false,
                    image: MediumItems.common.constant.IMAGE_MICROWAVE_PC,
                    id: MediumItems.common.constant.ID_MICROWAVE,
                    fee: 0,
                    fee_inc_tax: 0,
                    options: [],
                    selectedOptions: null,
                    totalFee: 0,
                    totalFeeIncTax: 0,
                },
                {
                    code: MediumItems.common.constant.CODE_VACUUM,
                    name: MediumItems.common.constant.NAME_VACUUM,
                    unit: MediumItems.common.constant.UNIT_VACUUM,
                    maxUnit: MediumItems.common.constant.MAXUNIT_VACUUM,
                    bizMaxUnitErrFlg: false,
                    numArray: [],
                    unitFlg: false,
                    image: MediumItems.common.constant.IMAGE_VACUUM_PC,
                    id: MediumItems.common.constant.ID_VACUUM,
                    fee: 0,
                    fee_inc_tax: 0,
                    options: [],
                    selectedOptions: null,
                    totalFee: 0,
                    totalFeeIncTax: 0,
                },
                {
                    code: MediumItems.common.constant.CODE_AP,
                    name: MediumItems.common.constant.NAME_AP,
                    unit: MediumItems.common.constant.UNIT_AP,
                    maxUnit: MediumItems.common.constant.MAXUNIT_AP,
                    bizMaxUnitErrFlg: false,
                    numArray: [],
                    unitFlg: false,
                    image: MediumItems.common.constant.IMAGE_AP_PC,
                    id: MediumItems.common.constant.ID_AP,
                    fee: 0,
                    fee_inc_tax: 0,
                    options: [],
                    selectedOptions: null,
                    totalFee: 0,
                    totalFeeIncTax: 0,
                },
                {
                    code: MediumItems.common.constant.CODE_PRINTER,
                    name: MediumItems.common.constant.NAME_PRINTER,
                    unit: MediumItems.common.constant.UNIT_PRINTER,
                    maxUnit: MediumItems.common.constant.MAXUNIT_PRINTER,
                    bizMaxUnitErrFlg: false,
                    numArray: [],
                    unitFlg: false,
                    image: MediumItems.common.constant.IMAGE_PRINTER_PC,
                    id: MediumItems.common.constant.ID_PRINTER,
                    fee: 0,
                    fee_inc_tax: 0,
                    options: [],
                    selectedOptions: null,
                    totalFee: 0,
                    totalFeeIncTax: 0,
                },
                {
                    code: MediumItems.common.constant.CODE_PC,
                    name: MediumItems.common.constant.NAME_PC,
                    unit: MediumItems.common.constant.UNIT_PC,
                    maxUnit: MediumItems.common.constant.MAXUNIT_PC,
                    bizMaxUnitErrFlg: false,
                    numArray: [],
                    unitFlg: false,
                    image: MediumItems.common.constant.IMAGE_PC_PC,
                    id: MediumItems.common.constant.ID_PC,
                    fee: 0,
                    fee_inc_tax: 0,
                    options: [],
                    selectedOptions: null,
                    totalFee: 0,
                    totalFeeIncTax: 0,
                },
                {
                    code: MediumItems.common.constant.CODE_CRT,
                    name: MediumItems.common.constant.NAME_CRT,
                    unit: MediumItems.common.constant.UNIT_CRT,
                    maxUnit: MediumItems.common.constant.MAXUNIT_CRT,
                    bizMaxUnitErrFlg: false,
                    numArray: [],
                    unitFlg:false,
                    image: MediumItems.common.constant.IMAGE_CRT_PC,
                    id: MediumItems.common.constant.ID_CRT,
                    fee: 0,
                    fee_inc_tax: 0,
                    options: [],
                    selectedOptions: null,
                    totalFee: 0,
                    totalFeeIncTax: 0,
                },
                {
                    code: MediumItems.common.constant.CODE_DESKTOP_MOUSE,
                    name: MediumItems.common.constant.NAME_DESKTOP_MOUSE,
                    unit: MediumItems.common.constant.UNIT_DESKTOP_MOUSE,
                    maxUnit: MediumItems.common.constant.MAXUNIT_DESKTOP_MOUSE,
                    bizMaxUnitErrFlg: false,
                    numArray: [],
                    unitFlg:false,
                    image: MediumItems.common.constant.IMAGE_DESKTOP_MOUSE_PC,
                    id: MediumItems.common.constant.ID_DESKTOP_MOUSE,
                    fee: 0,
                    fee_inc_tax: 0,
                    options: [],
                    selectedOptions: null,
                    totalFee: 0,
                    totalFeeIncTax: 0,
                },
                {
                    code: MediumItems.common.constant.CODE_NOTE_MOUSE,
                    name: MediumItems.common.constant.NAME_NOTE_MOUSE,
                    unit: MediumItems.common.constant.UNIT_NOTE_MOUSE,
                    maxUnit: MediumItems.common.constant.MAXUNIT_NOTE_MOUSE,
                    bizMaxUnitErrFlg: false,
                    numArray: [],
                    unitFlg:false,
                    image: MediumItems.common.constant.IMAGE_NOTE_MOUSE_PC,
                    id: MediumItems.common.constant.ID_NOTE_MOUSE,
                    fee: 0,
                    fee_inc_tax: 0,
                    options: [],
                    selectedOptions: null,
                    totalFee: 0,
                    totalFeeIncTax: 0,
                },
                {
                    code: MediumItems.common.constant.CODE_DISPLAY_MOUSE,
                    name: MediumItems.common.constant.NAME_DISPLAY_MOUSE,
                    unit: MediumItems.common.constant.UNIT_DISPLAY_MOUSE,
                    maxUnit: MediumItems.common.constant.MAXUNIT_DISPLAY_MOUSE,
                    bizMaxUnitErrFlg: false,
                    numArray: [],
                    unitFlg:false,
                    image: MediumItems.common.constant.IMAGE_DISPLAY_MOUSE_PC,
                    id: MediumItems.common.constant.ID_DISPLAY_MOUSE,
                    fee: 0,
                    fee_inc_tax: 0,
                    options: [],
                    selectedOptions: null,
                    totalFee: 0,
                    totalFeeIncTax: 0,
                },
                {
                    code: MediumItems.common.constant.CODE_LITHIUM_GAMING_MOUSE,
                    name: MediumItems.common.constant.NAME_LITHIUM_GAMING_MOUSE,
                    unit: MediumItems.common.constant.UNIT_LITHIUM_GAMING_MOUSE,
                    maxUnit: MediumItems.common.constant.MAXUNIT_LITHIUM_GAMING_MOUSE,
                    bizMaxUnitErrFlg: false,
                    numArray: [],
                    unitFlg:false,
                    image: MediumItems.common.constant.IMAGE_LITHIUM_GAMING_MOUSE_PC,
                    id: MediumItems.common.constant.ID_LITHIUM_GAMING_MOUSE,
                    fee: 0,
                    fee_inc_tax: 0,
                    options: [],
                    selectedOptions: null,
                    totalFee: 0,
                    totalFeeIncTax: 0,
                },
                {
                    code: MediumItems.common.constant.CODE_CRT_MOUSE,
                    name: MediumItems.common.constant.NAME_CRT_MOUSE,
                    unit: MediumItems.common.constant.UNIT_CRT_MOUSE,
                    maxUnit: MediumItems.common.constant.MAXUNIT_CRT_MOUSE,
                    bizMaxUnitErrFlg: false,
                    numArray: [],
                    unitFlg:false,
                    image: MediumItems.common.constant.IMAGE_CRT_MOUSE_PC,
                    id: MediumItems.common.constant.ID_CRT_MOUSE,
                    fee: 0,
                    fee_inc_tax: 0,
                    options: [],
                    selectedOptions: null,
                    totalFee: 0,
                    totalFeeIncTax: 0,
                }
            ],
            addItem: {
                code: MediumItems.common.constant.CODE_MEDIUM_OTHER,
                name: MediumItems.common.constant.NAME_MEDIUM_OTHER,
                labels: MediumItems.common.constant.LABELS_ADDITEM,
                unit: MediumItems.common.constant.UNIT_ADDITEM,
                maxUnit: MediumItems.common.constant.MAXUNIT_ADDITEM,
                bizMaxUnitErrFlg: false,
                numArray: [],
                unitFlg:false,
                fee: 0,
                fee_inc_tax: 0,
                options: [],
                selectedOptions: null,
                totalFee: 0,
                totalFeeIncTax: 0,
            },
            mediumBox: {
                medium_box_cnt: MediumItems.common.constant.MEDIUM_BOX_COUNT,
                mediumBoxSelectErrFlg: false,
                unitFlg: false,
            },
            styleObject: {},
            smallView: 0,
            largeView: 0,
            error: {
                no_items: false,
                no_items_without_large: false,
            },
            salesTaxRate: 0,
            maxQuantityBiz: MediumItems.common.constant.MAXQUANTITY_BIZ
        }
    },
    computed: {
        // 合計台数を計算
        totalUnits() {
            return MediumItems.getTotalUnits(this)
        }

    },
    watch: {
        totalUnits(newVal){
            MediumItems.limitTotalUnits(this, newVal)
        },
        'mediumBox.medium_box_cnt'(newVal) {
            this.mediumBox.unitFlg = newVal > 1;
        }
    },
    created() {
        MediumItems.inputRetention(this)
    },
    methods: {
        //台数選択のセレクトボックス表示
        createNumArray(item) {
            MediumItems.common.createNumArray(item)
        },
        setUnit(num, item) {
            MediumItems.setUnit(this, num, item)
        },
        submitMediumItems() {
            MediumItems.submitMediumItems(this)
        },
        pageBack() {
            MediumItems.pageBack(this)
        },
        setTotalFee(item) {
            MediumItems.setTotalFee(this, item)
        },
        showFeeUp(item) {
            return MediumItems.showFeeUp(this, item)
        },
        showFeeDown(item) {
            return MediumItems.showFeeDown(this, item)
        },
        displayItemDescription(item) {
            return MediumItems.common.displayItemDescription(this, item)
        },
        unitInput(item, event) {
            MediumItems.unitInput(item, event)
        },
        setDefault(item) {
            MediumItems.setDefault(item)
        },
    }
}

</script>
